import React, { useState } from 'react';
import { ChevronRight } from '@mui/icons-material';
import {
  Card,
  CardActionArea,
  CardContent,
  Collapse,
  Stack,
  Typography,
} from '@mui/material';
import ReactJson from 'react-json-view';
import { useTranslation } from 'react-i18next';
import IDKeys from '../constants/idKeys';

/**
 * Collapsible card to display the PS JSON blob.
 * @param {object} props Props accepted by the component.
 * @param {object} props.ps The PS to display.
 * @returns {import('react').FunctionComponent} React element that contains the JSON card.
 */
function JSONCard({ ps }) {
  const [viewSource, setViewSource] = useState(false);
  const [translate] = useTranslation();

  return (
    <Card
      key="viewSource"
      sx={{ width: '100%', borderRadius: 2, boxShadow: 0 }}
    >
      <CardActionArea
        id={`${IDKeys.JSON_CARD}ActionArea`}
        onClick={() => setViewSource(!viewSource)}
      >
        <CardContent>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography id={`${IDKeys.JSON_CARD}TitleText`} variant="body_lg">
              {translate('viewSourceTitle')}
            </Typography>
            <ChevronRight fontSize="large" />
          </Stack>
        </CardContent>
      </CardActionArea>
      <Collapse id={`${IDKeys.JSON_CARD}Content`} in={viewSource}>
        <ReactJson
          name={false}
          enableClipboard={false}
          displayObjectSize={false}
          displayDataTypes={false}
          src={ps ? JSON.parse(JSON.stringify(ps)) : null}
          indentWidth={2}
          style={{
            fontSize: '0.8em',
            maxHeight: '600px',
            padding: '8px',
            overflowY: 'auto',
          }}
        />
      </Collapse>
    </Card>
  );
}

export default JSONCard;
